// eslint-disable-next-line import/no-anonymous-default-export
export default {
  he: {
    Language: "עברית",
    title: "ReBuy ",
    Home: "בית",
    Notifications: "התראות",
    Map: "מפה",
    Upload: "העלה",
    Favorites: "מועדפים",
    Catagories: "קטגוריות",
    Administrator: "מנהל",
    sidebarTitle: "ניווט",
    description: "שלום",
    dashboard: "פעולה מהירה",
    components: "מסלול חינם",
    lobby: " ציר הזמן",
    multiLevel: " שלום",
    collapsed: "הסתר ניווט",
    rtl: "אנגלית",
    settings: "הגדרות כלליות",
    general: "כללי",
    help: "עזרה",
    disconnect: "התנתק",
    display: "תצוגה",
    welcome: "שלום ",
    profile: "פרופיל אישי",
    notification: "הודעות מערכת",
    Price: "מחיר",
    Category: "קטגוריה",
    Condition: "מצב",
    Search: "חיפוש",
    New: "חדש",
    Used: "משומש",
    Market: "חנות",
    username: "שלום משתמש!",
    Sport: "ספורט",
    Clothing: "ביגוד",
    Electricity: "אלקטרוניקה",
    Underwear: "הלבשה תחתונה",
    Swimwear: "בגדי ים",
    Homecare: "מוצרים לבית",
    Plants: "צמחים",
    Activewear: "ביגוד ספורט",
    Jewlery: "תכשיטים",
    Other: "אחר",
    MyProducts: "המוצרים שלי",
    CreateProduct: "העלאת מוצר חדש",
    Update: "עדכן",
    Delete: "מחק",
    MyFavorites: "המועדפים שלי",
    Recommendedforyou: "מומלצים בשבילך",
    AllProducts: "כל המוצרים",
    NotificationCenter: "מרכז ההודעות",
    intrestedPeople: "הודעות בקשר למוצר ",
  },

  en: {
    Language: "English",
    title: "ReBuy",
    Home: "Home",
    Notifications: "Notifications",
    Map: "Map",
    Upload: "Upload",
    Favorites: "Favorite",
    Catagories: "Catagories",
    Administrator: "Administrator",
    sidebarTitle: "Pro Sidebar",
    description: "",
    dashboard: "Dashboard",
    components: "Free User",
    lobby: "Lobby",
    medical: "My Medical Bag",
    dropdown: "Dropdown",
    submenu: "Submenu",
    multiLevel: "Multi Level",
    collapsed: "Collapsed",
    rtl: "Hebrew",
    image: "Background image",
    medicalsearch: "Medical Search",
    reminders: "Reminders",
    appointments: "Appointments",
    viewSource: "ReBuy",
    settings: "Settings",
    general: "general",
    help: "Help",
    disconnect: "Disconnect",
    DoctorTitle: "Find Doctors",
    symptom: "Symptom",
    display: "Display",
    welcome: "Welcome to ReBuy",
    money: "Money Control",
    profile: "Profile",
    notification: "Notification",
    Price: "Price",
    Category: "Category",
    Condition: "Condition",
    Search: "Search",
    New: "New",
    Used: "Used",
    Market: "Market",
    username: "Hello User!",
    Sport: "Sport",
    Clothing: "Clothing",
    Electricity: "Electricity",
    Underwear: "Underwear",
    Swimwear: "Swimwear",
    Homecare: "Homecare",
    Plants: "Plants",
    Activewear: "Activewear",
    Jewlery: "Jewlery",
    Other: "Other",
    MyProducts: "My Products",
    CreateProduct: "Create Product",
    Update: "Update",
    Delete: "Delete",
    MyFavorites: "My Favorites",
    Recommendedforyou: "Recommended for you",
    AllProducts: "All Products",
    NotificationCenter: "Notification Center",
    intrestedPeople: "People who interested your product",
  },
};
